/* eslint camelcase: 0 */
import { toUserProps } from './user'
import { RankingUser, Report } from '@/infrastructure/network/Monitaro/schema/models'
import { IReportProps, EmptyReportPropsFactory } from '@/entities/Report'
import { EmptyUserPropsFactory, IUserProps } from '@/entities/User'

export const toReportProps = (props: Report | null | undefined): IReportProps => {
  if (!props) {
    return EmptyReportPropsFactory()
  }

  const { reports, totals, appointments, checkins, registrations, withdrawals, started_at, ended_at } = props

  return EmptyReportPropsFactory({
    reports,
    totals,
    appointments: appointments?.map(toRankingUserProps),
    checkins: checkins?.map(toRankingUserProps),
    registrations: registrations?.map(toRankingUserProps),
    withdrawals: withdrawals?.map(toRankingUserProps),
    startedAt: started_at,
    endedAt: ended_at
  })
}

export const toRankingUserProps = (props: RankingUser | null | undefined): { count: number; user: IUserProps } => {
  if (!props) {
    return { count: 0, user: EmptyUserPropsFactory() }
  }

  const { count, user } = props

  return {
    count,
    user: toUserProps(user)
  }
}
